const DarkmodeInitiator = {
  init({
    toogleBtnMode, body, button, drawer, mode,
  }) {
    const dark = `
      <img src="./icons/moon-icon.svg" alt="moon icon" class="w-10 me-1">
      Dark
    `;
    const light = `
      <img src="./icons/light-icon.svg" alt="light icon" class="w-10 me-1">
      Light
    `;
    if (mode && mode === 'dark') {
      this._darkMode({
        body, button, drawer, toogleBtnMode, light,
      });
    }
    toogleBtnMode.addEventListener('click', () => {
      body.classList.toggle('dark-mode');
      if (body.classList.contains('dark-mode')) {
        this._darkMode({
          body, button, drawer, toogleBtnMode, light,
        });
      } else {
        this._lightMode({
          body, button, drawer, toogleBtnMode, dark,
        });
      }
    });
  },

  _darkMode({
    body, button, drawer, toogleBtnMode, light,
  }) {
    body.classList.add('dark-mode');
    button.classList.add('bg-[#35A29F]', 'rounded-md');
    drawer.classList.remove('bg-white');
    drawer.classList.add('bg-black');
    toogleBtnMode.firstElementChild.classList.add('bg-white');
    toogleBtnMode.firstElementChild.innerHTML = light;
    localStorage.setItem('MODE', 'dark');
  },

  _lightMode({
    body, button, drawer, toogleBtnMode, dark,
  }) {
    body.classList.remove('dark-mode');
    button.classList.remove('bg-[#35A29F]', 'rounded-md');
    drawer.classList.add('bg-white');
    drawer.classList.remove('bg-black');
    toogleBtnMode.firstElementChild.classList.remove('bg-white');
    toogleBtnMode.firstElementChild.innerHTML = dark;
    localStorage.setItem('MODE', 'light');
  },
};

export default DarkmodeInitiator;
